import React from 'react';
import { Table } from 'antd';
import { Eye, TriangleAlert, UserCheck } from 'lucide-react';
import { StatusTag, IconAction, IconActions, EmptyState } from '../../../common';
import { fmtVZ } from '../../../../utils/timeUtils';
import { channelTag } from './TopPromotorsTable';
import { t } from '../../../../company/labels';

function InactivePromotorsTable({ promotors, loading, period, navigateToPromoter }) {
    const periodLabel = period === 'day' ? 'hoy' : period === 'week' ? 'esta semana' : 'este mes';

    const columns = [
        {
            title: t('promotor'),
            dataIndex: 'name',
            key: 'name',
            render: (name, record) => (
                <div className="flex items-center gap-2.5">
                    <TriangleAlert className="shrink-0 text-[14px] text-warning-solid" />
                    <div className="min-w-0">
                        <p className="m-0 text-sm font-medium text-surface-900">{name}</p>
                        <p className="m-0 text-xs text-surface-500">{record.email}</p>
                    </div>
                </div>
            )
        },
        {
            title: 'Canal',
            dataIndex: 'channel',
            key: 'channel',
            render: channelTag
        },
        {
            title: 'Tiendas Asignadas',
            dataIndex: 'totalAssignedStores',
            key: 'totalAssignedStores',
            align: 'right',
            render: (count) => <span className="font-medium text-surface-700 tabular-nums">{count || 0}</span>
        },
        {
            title: 'Registrado',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: (date) => <span className="text-sm text-surface-500 tabular-nums">{fmtVZ(date, 'DD/MM/YYYY')}</span>
        },
        {
            title: 'Estado',
            key: 'status',
            render: () => (
                <StatusTag tone="danger" dot>
                    Sin actividad {periodLabel}
                </StatusTag>
            )
        },
        {
            title: 'Acciones',
            key: 'actions',
            align: 'right',
            render: (_, record) => (
                <IconActions>
                    <IconAction icon={<Eye />} label="Ver Detalle" onClick={() => navigateToPromoter(record._id)} />
                </IconActions>
            )
        }
    ];

    return (
        <div>
            <div className="mx-5 my-4 flex items-start gap-2 rounded-lg border border-warning-border bg-warning-bg px-3 py-2.5 text-sm text-warning-fg">
                <TriangleAlert className="mt-0.5 shrink-0" />
                <span>{t('promotores')} que no han registrado actividad {periodLabel}</span>
            </div>

            <Table
                columns={columns}
                dataSource={promotors}
                loading={loading}
                rowKey="_id"
                size="middle"
                pagination={{
                    pageSize: 10,
                    showSizeChanger: false
                }}
                locale={{
                    emptyText: <EmptyState icon={<UserCheck />} title={`Todos los ${t('promotoresLower')} han sido activos ${periodLabel}`} />
                }}
                scroll={{ x: 700 }}
            />
        </div>
    );
}

export default InactivePromotorsTable;
